import { render, staticRenderFns } from "./cancellationdetail.vue?vue&type=template&id=6a116d1d&scoped=true"
import script from "./cancellationdetail.vue?vue&type=script&lang=js"
export * from "./cancellationdetail.vue?vue&type=script&lang=js"
import style0 from "./cancellationdetail.vue?vue&type=style&index=0&id=6a116d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a116d1d",
  null
  
)

export default component.exports